import { render, staticRenderFns } from "./tabObjectGoods.vue?vue&type=template&id=377463ef&"
import script from "./tabObjectGoods.vue?vue&type=script&lang=js&"
export * from "./tabObjectGoods.vue?vue&type=script&lang=js&"
import style0 from "./tabObjectGoods.vue?vue&type=style&index=0&id=377463ef&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports